import styled from 'styled-components';
export const Divider = styled.hr `
  background-color: ${({ theme }) => theme.colors.grey.light};
  height: 1px;
  border: 0;
  margin-bottom: ${({ mb = 0 }) => mb};
  margin-top: ${({ mt = 0 }) => mt};
  width: 100%;
`;
